import _flatten from 'lodash/flatten'
import _get from 'lodash/get'

import { ERROR_MESSAGE_GENERIC, REQUEST_ERROR_MESSAGES, REQUEST_SUCCESS_MESSAGES } from '../constants'
import { LoudCustomRequestError, SilentCustomRequestError } from '../helpers/requestErrors'
import { receiveErrorAlerts, receiveSuccessAlert } from './alerts'

export const START_REQUEST = 'START_REQUEST'
export const END_REQUEST = 'END_REQUEST'

export const startRequest = (data) => ({ type: START_REQUEST, data })

export const endRequest = (data) => ({ type: END_REQUEST, data })

export const handleRequestSuccess =
    ({ requestType }) =>
    (dispatch) => {
        if (!REQUEST_SUCCESS_MESSAGES[requestType]) return
        dispatch(receiveSuccessAlert(REQUEST_SUCCESS_MESSAGES[requestType]))
    }

export const handleRequestError =
    (error, { requestType = null, customMessage = null, hideAlert = false } = {}) =>
    (dispatch) => {
        if (error instanceof LoudCustomRequestError) {
            dispatch(receiveErrorAlerts(error.message))
            return
        }

        if (error instanceof SilentCustomRequestError) {
            return
        }

        const errorMessage = []

        const serverErrorMessage = parseServerError(error)

        if (customMessage) {
            errorMessage.push(customMessage)
        } else if (requestType) {
            errorMessage.push(REQUEST_ERROR_MESSAGES[requestType] || ERROR_MESSAGE_GENERIC)
        } else {
            errorMessage.push(ERROR_MESSAGE_GENERIC)
        }

        if (!hideAlert) {
            dispatch(receiveErrorAlerts(errorMessage.join(' ')))

            if (serverErrorMessage) {
                dispatch(receiveErrorAlerts(serverErrorMessage.join(' ')))
            }
        }

        if (hideAlert && customMessage) {
            dispatch(receiveErrorAlerts(customMessage))
        }
    }

const parseServerError = (error) => {
    const data = _get(error, ['response', 'data'])

    const errorMessage = []

    if (data) {
        const status = _get(error, ['response', 'status'])
        const message = _get(data, ['message'])
        const modelState = _get(data, ['modelState'])

        if (message) {
            errorMessage.push(message)
        }

        if (modelState) {
            errorMessage.push(getModelStateMessages(modelState))
        }

        if (!message && !modelState) {
            errorMessage.push(JSON.stringify(data))
        }

        if (status) {
            errorMessage.push(`(${status})`)
        }
    }

    if (!errorMessage.length) return null

    return errorMessage
}

const getModelStateMessages = (modelState) => {
    const messages = [...new Set(_flatten(Object.values(modelState)))]

    return `${messages.join('. ')}.`
}
